import styled from 'styled-components';
import {BGImageCenter, LIGHT_BLUE4} from '../../../../../../../../globalVariables/GlobalVariables';
import {dFlexBetween, dFlex, alignCenter, flexWrap, justifyStart} from '../../../../../../../../globalVariables/GlobalFlex';

export const row = styled.div`
    ${dFlexBetween}
    width: 100%;
    height: 45px;
    border-top: 2px solid ${LIGHT_BLUE4}75;
    padding-inline: 15px;
`;

export const section = styled.div`
    ${dFlex}
    ${alignCenter}
    ${justifyStart}
    ${flexWrap}
    width: calc(100% - 150px);
    column-gap: 8px;
`;

export const item = styled.div<{icon?: string}>`
    ${p=>p.icon && `
        ${dFlex}
        ${alignCenter}
        gap: 5px;
        &::before{
            content: '';
            display: block;
            width: 15px;
            height: 15px;
            ${BGImageCenter(p.icon, 'cover')}
        }
    `}
`;